<template>
  <Component :is="continuous ? 'div' : BaseCard" :class="containerClasses" id="candidateBadges">
    <p class="mb-8 w-32 bg-gradient-to-r bg-clip-text font-bold text-transparent from-bdBlue-600 to-bdPurple-600">
      Badges.</p>
    <CandidateBadges :candidate="candidate" class="mb-4"/>
  </Component>
</template>

<script setup>
import BaseCard from "./BaseCard.vue";
import CandidateBadges from "./CandidateBadges.vue";
import {computed} from "vue";

const props = defineProps({
  candidate: Object,
  continuous: Boolean,
  small: Boolean,
});

const containerClasses = computed(() => {
  const baseClasses = props.continuous ? "px-4 md:px-6 mt-6" : "relative shadow-sm mt-6";
  return baseClasses + (props.small ? " text-sm" : " text-base");
});
</script>
